/**
 * Third-party tracking & chat configuration.
 *
 * GTM: Set your Google Tag Manager container ID (e.g., "GTM-XXXXXXX").
 * Tawk.to: Set your property ID and widget ID from tawk.to dashboard.
 *
 * Leave values empty ("") to disable the integration.
 */
export const trackingConfig = {
  /** Google Tag Manager container ID, e.g. "GTM-XXXXXXX" */
  gtmId: "GTM-PCPSGCV",

  /** Tawk.to property ID — found in tawk.to Dashboard → Administration → Property Settings */
  tawkPropertyId: "",  // Loaded via GTM — do not set here to avoid double-loading

  /** Tawk.to widget ID — typically "default" or found in the embed code */
  tawkWidgetId: "default",
};
